import { Grid, GridItem, Heading, Stack, Text } from '@chakra-ui/react';
import { getPrettyProviderDataMap } from '@pelicargo/utils';
import { ProviderDataMap, ProviderDataMapType } from '@prisma/client';

import { SimpleFieldArray } from '../SimpleFieldArray';
import { SimpleSwitch } from '../SimpleSwitch';
import { ProviderDataMapForm } from './ProviderDataMapForm';

const apiMapValues = Object.values(ProviderDataMapType);

export const ProviderApiForm = () => {
  const getMappedDataTitle = (field: ProviderDataMap) => {
    return (
      <Grid templateColumns="repeat(2, 1fr)" w="full">
        <GridItem>
          <Text fontFamily="monospace">{field?.resultValue}</Text>
        </GridItem>
        <GridItem>
          <Text fontFamily="monospace">{field?.checkValue}</Text>
        </GridItem>
      </Grid>
    );
  };

  const renderDataMap = (type: ProviderDataMapType) => {
    const prettyType = getPrettyProviderDataMap(type);

    return (
      <Stack key={type} direction="column" borderWidth={1} spacing={8} p={4}>
        <Heading>{prettyType} Mapping</Heading>
        <SimpleFieldArray
          name={`mapped_data_by_type.${type}`}
          form={ProviderDataMapForm}
          canAdd
          addLabel={`Add ${prettyType}`}
          canRemove
          accordionTitle={getMappedDataTitle}
          ignoreStyles
        />
      </Stack>
    );
  };

  return (
    <>
      <Stack direction="column" spacing="4" w="full">
        <SimpleSwitch name="has_api_quoting" label="Enable API-Quoting" />
        <SimpleSwitch name="has_api_booking" label="Enable API-Booking" />
        <SimpleSwitch name="has_api_booking_without_awb" label="Enable API-Booking without AWB" />
        <SimpleSwitch name="has_api_cancellation" label="Enable API-Cancellation" />

        {apiMapValues.map(renderDataMap)}
      </Stack>
    </>
  );
};
